import { ParseKeys } from "i18next";
import { QuoteApprovalStatus } from "generated/graphql";

export interface QuoteStatusMeta {
  /** A `quotes` key. */
  label: ParseKeys<"quotes">;
  color: string;
}

/**
 * How a quote's approval state reads to each side. "Pending" is the only one
 * that needs different wording — it is the customer who owes an answer, so the
 * vendor sees who they are waiting on rather than an instruction.
 */
const PENDING_COLOR = "#f59e0b";

export const QUOTE_APPROVAL_META: Record<QuoteApprovalStatus, QuoteStatusMeta> =
  {
    [QuoteApprovalStatus.Pending]: {
      label: "status.awaiting_approval",
      color: PENDING_COLOR,
    },
    [QuoteApprovalStatus.Approved]: {
      label: "status.approved",
      color: "#22c55e",
    },
    [QuoteApprovalStatus.ChangesRequested]: {
      label: "status.changes_requested",
      color: "#6366f1",
    },
  };

export const quoteStatusMeta = (
  status: QuoteApprovalStatus,
  side: "customer" | "vendor",
): QuoteStatusMeta =>
  status === QuoteApprovalStatus.Pending
    ? {
        label:
          side === "customer"
            ? "status.awaiting_your_approval"
            : "status.awaiting_customer",
        color: PENDING_COLOR,
      }
    : QUOTE_APPROVAL_META[status];
